import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "busy-indicator-container"
}
const _hoisted_2 = { class: "league-standings-container" }
const _hoisted_3 = {
  key: 0,
  class: "noprint"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "table-controls" }

import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

import BusyIndicator from '@/components/common/BusyIndicator.vue'
import NotificationBanner from '@/components/common/NotificationBanner.vue'
import PrintButton from '@/components/common/PrintButton'
import LeagueSections from '@/components/widgets/public/LeagueSections.vue'
import { useLeaguesStore } from '@/store/public/leagues'
import { getErrorMessage } from '@/utils/error-handling'


export default /*@__PURE__*/_defineComponent({
  __name: 'LeagueDetailView',
  setup(__props) {

const leagues = useLeaguesStore()
const route = useRoute()

const errorMessage = ref<string | null>(null)
const isLoading = ref<boolean>(false)

onMounted(async () => {
  errorMessage.value = null
  isLoading.value = true

  try {
    await leagues.selectLeagueById(route.params.id as string)
  } catch (e) {
    const message = getErrorMessage(e as Error)
    console.error(`Failed fetching leagues: ${message}`)
    errorMessage.value = message
  }

  isLoading.value = false
})

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("h1", _hoisted_1, [
        _createVNode(BusyIndicator)
      ]))
    : (errorMessage.value)
      ? (_openBlock(), _createBlock(NotificationBanner, {
          key: 1,
          message: errorMessage.value,
          "is-danger": ""
        }, null, 8, ["message"]))
      : ((_unref(leagues).selectedLeague?.sections ?? []).length === 0)
        ? (_openBlock(), _createBlock(NotificationBanner, {
            key: 2,
            message: _ctx.$t('leagues.errors.no-sections'),
            "is-warning": ""
          }, null, 8, ["message"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("div", _hoisted_2, [
              (_unref(leagues).selectedLeague?.name)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_unref(leagues).selectedLeague?.name), 1))
                : _createCommentVNode("", true),
              (_unref(leagues).selectedLeague?.description)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(leagues).selectedLeague?.description), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(PrintButton)),
                _createVNode(_component_RouterLink, {
                  to: {
            path: `/leagues/${_unref(leagues).selectedSeason}/${_unref(leagues).selectedLeague?.id}/standings`,
          },
                  class: "standings-link noprint"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("small", null, [
                      _createVNode(_component_FontAwesomeIcon, {
                        class: "icon",
                        icon: "file-contract"
                      }),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('leagues.labels.standings')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ]),
            _createVNode(LeagueSections)
          ], 64))
}
}

})